import { call, put, takeLatest, select } from "redux-saga/effects";
import {
  fetchRSSIHistorySuccess,
  fetchRSSIHistoryFailure,
  fetchHumiditySuccess,
  fetchHumidityFailure,
  fetchBatteryHistorySuccess,
  fetchBatteryHistoryFailure,
  fetchPressureSuccess,
  fetchPressureFailure,
  fetchSignalHistorySuccess,
  fetchSignalHistoryFailure,
  fetchTemperatureSuccess,
  fetchTemperatureFailure,
  deviceShipmentsDashboardTypes,
  fetchLightSuccess,
  fetchLightFailure,
  fetchTiltSuccess,
  fetchTiltFailure,
  fetchShockAlarmHistorySuccess,
  fetchShockAlarmHistoryFailure,
} from "../actions/deviceShipmentsDashboard";
import { fetchassetmapEndPoint } from "../../configuration";
import { getRandomUUID } from "../../Token";
import { v4 as uuidv4 } from "uuid";
import timeAgoCalculator from "../../global/utility//timeAgoCalculator";

function* fetchRSSIHistorySaga() {
  try {
    const options = yield select((state) => {
      return {
        currentId: state.shipmentDashboard.currentId,
        startDateTime: state.shipmentDashboard.startDateTime,
        endDateTime: state.shipmentDashboard.endDateTime,
        isAsc: state.shipmentDashboard.isAsc,
      };
    });

    const rssiHistoryResponse = yield call(
      fetchRSSIAPI,
      options.currentId,
      options.startDateTime,
      options.endDateTime,
      options.isAsc
    );

     let rssiHistory = {
      timeAgo: "",
      rssi: [],
    };

     if (rssiHistoryResponse && rssiHistoryResponse?.data) {
      rssiHistory = rssiHistoryResponse?.data.reduce(
        (acc, rssiHistoryData) => {
          acc.rssi = [
            ...acc.rssi,
            [rssiHistoryData.createdon, rssiHistoryData.fields.rssi],
          ];

          return acc;
        },
        {
          timeAgo: "",
          rssi: [],
        }
      );
    }
     const lastrssiEntry = rssiHistory?.rssi?.[rssiHistory.rssi.length - 1];
    rssiHistory = {
      ...rssiHistory,
      timeAgo:lastrssiEntry ? timeAgoCalculator(lastrssiEntry[0]) : null,
    };

  //   const rssiHistoryData = Object.entries(rssiHistoryResponse?.rssi || {});
  //   let rssiHistory = [];
  //  console.log("rssiHistoryData",rssiHistoryResponse)
  //   if (Array.isArray(rssiHistoryData)) {
  //     rssiHistoryData.sort((a, b) => new Date(a[0]) - new Date(b[0]));
  //     rssiHistoryData.forEach((rssiData) => {
  //       rssiHistory = [...rssiHistory, [rssiData[0], rssiData[1].Value]];
  //     });
  //   }

    yield put(fetchRSSIHistorySuccess(rssiHistory));
  } catch (error) {
    yield put(fetchRSSIHistoryFailure(error.message));
  }
}

async function fetchRSSIAPI(deviceId, startDateTime, endDateTime, isAsc) {
  const response = await fetch(fetchassetmapEndPoint(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      $filter: `(deviceid eq '${deviceId}' AND $/fields containskey 'rssi' AND createdon between('${startDateTime}','${endDateTime}'))`,
      $sort: [{ field: "createdon", order: !isAsc ? "desc" : "asc" }],
    }),
  });

  if (!response.ok) return [];

  return response.json();
}

function* fetchHumiditySaga() {
  try {
    const options = yield select((state) => {
      return {
        currentId: state.shipmentDashboard.currentId,
        startDateTime: state.shipmentDashboard.startDateTime,
        endDateTime: state.shipmentDashboard.endDateTime,
      };
    });
    const HumidityResponse = yield call(
      fetchHumidityAPI,
      options.currentId,
      options.startDateTime,
      options.endDateTime
    );
    let Humidity = {
      timeAgo: "",
      humidity: [],
    };

    if (HumidityResponse && HumidityResponse.data) {
      // Process the humidity data from the API response
      Humidity = HumidityResponse.data.reduce(
        (acc, humidityData) => {
          // const localeDateString = humidityData.createdon.split("T")[0];
          // const availableIndex = acc.humidity.findIndex(
          //   (bat) => bat[0].split("T")[0] === localeDateString
          // );

          // Check if data for that date exists, if not, add new entry
          // if (availableIndex === -1) {
          //   acc.humidity = [
          //     ...acc.humidity,
          //     [humidityData.createdon, humidityData.fields.humidity],
          //   ];
          // } else if (
          //   acc.humidity[availableIndex][1] < humidityData.fields.humidity
          // ) {
          //   // If we have higher humidity for the same date, replace it
          //   acc.humidity[availableIndex] = [
          //     humidityData.createdon,
          //     humidityData.fields.humidity,
          //   ];
          // }

          acc.humidity = [
            ...acc.humidity,
            [humidityData.createdon, humidityData.fields.humidity],
          ];

          return acc;
        },
        {
          timeAgo: "",
          humidity: [],
        }
      );
    }

    // Calculate timeAgo for the last humidity entry
    // Humidity = {
    //   ...Humidity,
    //   timeAgo: timeAgoCalculator(
    //     Humidity.humidity[Humidity.humidity.length - 1][0]
    //   ),
    // };
    const lastHumidityEntry = Humidity?.humidity?.[Humidity.humidity.length - 1];
    Humidity = {
      ...Humidity,
      timeAgo: lastHumidityEntry ? timeAgoCalculator(lastHumidityEntry[0]) : null,
    };

    yield put(fetchHumiditySuccess(Humidity));
  } catch (error) {
    yield put(fetchHumidityFailure(error.message));
  }
}

function* fetchLightSaga() {
  try {
    const options = yield select((state) => {
      return {
        currentId: state.shipmentDashboard.currentId,
        startDateTime: state.shipmentDashboard.startDateTime,
        endDateTime: state.shipmentDashboard.endDateTime,
      };
    });
    const LightResponse = yield call(
      fetchLightAPI,
      options.currentId,
      options.startDateTime,
      options.endDateTime
    );
    let Light = {
      timeAgo: "",
      light: [],
    };

    if (LightResponse && LightResponse.data) {
      // Process the Light data from the API response
      Light = LightResponse.data.reduce(
        (acc, lightData) => {
          acc.light = [
            ...acc.light,
            [lightData.createdon, lightData.fields.light],
          ];

          return acc;
        },
        {
          timeAgo: "",
          light: [],
        }
      );
    }
    const lastLightEntry = Light?.light?.[Light.light.length - 1];
    Light = {
      ...Light,
      timeAgo: lastLightEntry ? timeAgoCalculator(lastLightEntry[0]) : null,
    };

    yield put(fetchLightSuccess(Light));
  } catch (error) {
    yield put(fetchLightFailure(error.message));
  }
}

function* fetchTiltSaga() {
  try {
    const options = yield select((state) => {
      return {
        currentId: state.shipmentDashboard.currentId,
        startDateTime: state.shipmentDashboard.startDateTime,
        endDateTime: state.shipmentDashboard.endDateTime,
      };
    });
    const TiltResponse = yield call(
      fetchTiltAPI,
      options.currentId,
      options.startDateTime,
      options.endDateTime
    );
    let Tilt = {
      timeAgo: "",
      tilt: [],
    };

    if (TiltResponse && TiltResponse.data) {
      // Process the Tilt data from the API response
      Tilt = TiltResponse.data.reduce(
        (acc, tiltData) => {
          acc.tilt = [
            ...acc.tilt,
             [tiltData?.createdon, tiltData?.fields?.orientation?.tiltZ],
            //  [tiltData.createdon, tiltData.fields?.deviceAlarm?.gyro?.inclination],
          ];

          return acc;
        },
        {
          timeAgo: "",
          tilt: [],
        }
      );
    }
    const lastTiltEntry = Tilt?.tilt?.[Tilt.tilt.length - 1];
    Tilt = {
      ...Tilt,
      timeAgo: lastTiltEntry ? timeAgoCalculator(lastTiltEntry[0]) : null,
    };

    yield put(fetchTiltSuccess(Tilt));
  } catch (error) {
    yield put(fetchTiltFailure(error.message));
  }
}

async function fetchHumidityAPI(deviceId, startDateTime, endDateTime) {
  const response = await fetch(fetchassetmapEndPoint(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      $filter: `(deviceid eq '${deviceId}' AND $/fields containskey 'humidity' AND createdon between('${startDateTime}','${endDateTime}'))`,
      $sort: [{ field: "createdon", order: "asc" }],
    }),
  });

  if (!response.ok) return [];

  return response.json();
}

async function fetchTiltAPI(deviceId, startDateTime, endDateTime) {
  const response = await fetch(fetchassetmapEndPoint(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      $filter: `(deviceid eq '${deviceId}' AND $/fields/orientation containskey 'tiltZ'  AND createdon between('${startDateTime}','${endDateTime}'))`,
      $sort: [{ field: "createdon", order: "asc" }],
    }),
  });

  if (!response.ok) return [];

  return response.json();
}

async function fetchLightAPI(deviceId, startDateTime, endDateTime) {
  const response = await fetch(fetchassetmapEndPoint(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      $filter: `(deviceid eq '${deviceId}' AND $/fields containskey 'light' AND createdon between('${startDateTime}','${endDateTime}'))`,
      $sort: [{ field: "createdon", order: "asc" }],
    }),
  });

  if (!response.ok) return [];

  return response.json();
}

function* fetchBatteryHistorySaga() {
  try {
    const options = yield select((state) => {
      return {
        currentId: state.shipmentDashboard.currentId,
        startDateTime: state.shipmentDashboard.startDateTime,
        endDateTime: state.shipmentDashboard.endDateTime,
      };
    });

    const batteryHistoryResponse = yield call(
      fetchBatteryHistoryAPI,
      options.currentId,
      options.startDateTime,
      options.endDateTime
    );

    let batteryHistory = {
      timeAgo: "",
      battery: [],
    };

    if (batteryHistoryResponse && batteryHistoryResponse.data) {
      // Process the humidity data from the API response
      batteryHistory = batteryHistoryResponse.data.reduce(
        (acc, batteryData) => {
          // const localeDateString = batteryData.createdon.split("T")[0];
          // const availableIndex = acc.battery.findIndex(
          //   (bat) => bat[0].split("T")[0] === localeDateString
          // );

          // Check if data for that date exists, if not, add new entry
          // if (availableIndex === -1) {
          //   acc.battery = [
          //     ...acc.battery,
          //     [batteryData.createdon, batteryData.fields.battery],
          //   ];
          // } else if (
          //   acc.battery[availableIndex][1] < batteryData.fields.battery
          // ) {
          //   // If we have higher humidity for the same date, replace it
          //   acc.battery[availableIndex] = [
          //     batteryData.createdon,
          //     batteryData.fields.battery,
          //   ];
          // }

          acc.battery = [
            ...acc.battery,
            [batteryData.createdon, batteryData.fields.battery],
          ];

          return acc;
        },
        {
          timeAgo: "",
          battery: [],
        }
      );
    }

    // Calculate timeAgo for the last humidity entry
    const lastBatteryEntry = batteryHistory?.battery?.[batteryHistory.battery.length - 1];
    batteryHistory = {
      ...batteryHistory,
      timeAgo:lastBatteryEntry ? timeAgoCalculator(lastBatteryEntry[0]) : null,
    };
    // batteryHistory = {
    //   ...batteryHistory,
    //   timeAgo: timeAgoCalculator(
    //     batteryHistory?.battery?.[batteryHistory.battery.length - 1][0]
    //   ),
    // };

    yield put(fetchBatteryHistorySuccess(batteryHistory));
  } catch (error) {
    console.log("error", error);
    yield put(fetchBatteryHistoryFailure(error.message));
  }
}
function* fetchTemperatureSaga() {
  try {
    const options = yield select((state) => {
      return {
        currentId: state.shipmentDashboard.currentId,
        startDateTime: state.shipmentDashboard.startDateTime,
        endDateTime: state.shipmentDashboard.endDateTime,
      };
    });

    const TemperatureResponse = yield call(
      fetchTemperatureAPI,
      options.currentId,
      options.startDateTime,
      options.endDateTime
    );
    let Temperature = {
      timeAgo: "",
      temperature: [],
    };

    if (TemperatureResponse && TemperatureResponse.data) {
      // Process the humidity data from the API response
      Temperature = TemperatureResponse.data.reduce(
        (acc, temperatureData) => {
          // const localeDateString = temperatureData?.createdon?.split("T")[0];
          // const availableIndex = acc?.temperature?.findIndex(
          //   (bat) => bat[0]?.split("T")[0] === localeDateString
          // );

          // Check if data for that date exists, if not, add new entry
          // if (availableIndex === -1) {
          //   acc.temperature = [
          //     ...acc.temperature,
          //     [temperatureData.createdon, temperatureData.fields.temperature],
          //   ];
          // } else if (
          //   acc.temperature[availableIndex][1] <
          //   temperatureData.fields.temperature
          // ) {
          //   // If we have higher humidity for the same date, replace it
          //   acc.temperature[availableIndex] = [
          //     temperatureData.createdon,
          //     temperatureData.fields.temperature,
          //   ];
          // }

          acc.temperature = [
            ...acc.temperature,
            [temperatureData.createdon, temperatureData.fields.temperature],
          ];

          return acc;
        },
        {
          timeAgo: "",
          temperature: [],
        }
      );
    }

    // Calculate timeAgo for the last humidity entry
    if (
      Array.isArray(Temperature.temperature) &&
      Temperature.temperature.length > 0
    ) {
      Temperature = {
        ...Temperature,
        timeAgo: timeAgoCalculator(
          Temperature.temperature[Temperature.temperature.length - 1][0]
        ),
      };
    }
    yield put(fetchTemperatureSuccess(Temperature));
  } catch (error) {
    console.log("error", error);
    yield put(fetchTemperatureFailure(error.message));
  }
}

async function fetchBatteryHistoryAPI(deviceId, startDateTime, endDateTime) {
  const response = await fetch(fetchassetmapEndPoint(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      $filter: `(deviceid eq '${deviceId}' AND $/fields containskey 'battery' AND createdon between('${startDateTime}','${endDateTime}'))`,
      $sort: [{ field: "createdon", order: "asc" }],
    }),
  });

  if (!response.ok) return [];

  return response.json();
}

async function fetchTemperatureAPI(deviceId, startDateTime, endDateTime) {
  const response = await fetch(fetchassetmapEndPoint(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      $filter: `(deviceid eq '${deviceId}' AND $/fields containskey 'temperature' AND createdon between('${startDateTime}','${endDateTime}'))`,
      $sort: [{ field: "createdon", order: "asc" }],
    }),
  });

  if (!response.ok) return [];

  return response.json();
}

function* fetchPressureSaga() {
  try {
    const options = yield select((state) => {
      return {
        currentId: state.shipmentDashboard.currentId,
        startDateTime: state.shipmentDashboard.startDateTime,
        endDateTime: state.shipmentDashboard.endDateTime,
      };
    });

    const PressureResponse = yield call(
      fetchPressureAPI,
      options.currentId,
      options.startDateTime,
      options.endDateTime
    );

    let Pressure = {
      timeAgo: "",
      pressure: [],
    };

    if (PressureResponse && PressureResponse.data) {
      // Process the humidity data from the API response
      Pressure = PressureResponse.data.reduce(
        (acc, pressureData) => {
          // const localeDateString = pressureData.createdon.split("T")[0];
          // const availableIndex = acc.pressure.findIndex(
          //   (bat) => bat[0].split("T")[0] === localeDateString
          // );

          // Check if data for that date exists, if not, add new entry
          // if (availableIndex === -1) {
          //   acc.pressure = [
          //     ...acc.pressure,
          //     [pressureData.createdon, pressureData.fields.pressure],
          //   ];
          // } else if (
          //   acc.pressure[availableIndex][1] < pressureData.fields.pressure
          // ) {
          //   // If we have higher humidity for the same date, replace it
          //   acc.pressure[availableIndex] = [
          //     pressureData.createdon,
          //     pressureData.fields.pressure,
          //   ];
          // }

          acc.pressure = [
                ...acc.pressure,
                [pressureData.createdon, pressureData.fields.pressure],
          ];

          return acc;
        },
        {
          timeAgo: "",
          pressure: [],
        }
      );
    }

    // Calculate timeAgo for the last humidity entry
    // Pressure = {
    //   ...Pressure,
    //   timeAgo: timeAgoCalculator(
    //     Pressure.pressure[Pressure.pressure.length - 1][0]
    //   ),
    // };
    const lastPressureEntry = Pressure?.pressure?.[Pressure.pressure.length - 1];
    Pressure = {
      ...Pressure,
      timeAgo: lastPressureEntry ? timeAgoCalculator(lastPressureEntry[0]) : null,
    };

    yield put(fetchPressureSuccess(Pressure));
  } catch (error) {
    yield put(fetchPressureFailure(error.message));
  }
}

async function fetchPressureAPI(deviceId, startDateTime, endDateTime) {
  const response = await fetch(fetchassetmapEndPoint(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      $filter: `(deviceid eq '${deviceId}' AND $/fields containskey 'pressure' AND createdon between('${startDateTime}','${endDateTime}'))`,
      $sort: [{ field: "createdon", order: "asc" }],
    }),
  });

  if (!response.ok) return [];

  return response.json();
}

function* fetchSignalHistorySaga() {
  try {
    const options = yield select((state) => {
      return {
        currentId: state.shipmentDashboard.currentId,
        startDateTime: state.shipmentDashboard.startDateTime,
        endDateTime: state.shipmentDashboard.endDateTime,
      };
    });

    const signalStrengthHistoryResponse = yield call(
      fetchSignalHistoryAPI,
      options.currentId,
      options.startDateTime,
      options.endDateTime
    );

    let signalStrengthHistoryData = [];
    if (
      Array.isArray(signalStrengthHistoryResponse.data) &&
      signalStrengthHistoryResponse.data.length > 0
    ) {
      signalStrengthHistoryData = signalStrengthHistoryResponse.data.map(
        (signalStrengthHistory) => [
          signalStrengthHistory.lastupdated,
          {
            value: signalStrengthHistory.fields.signalStrength,
          },
        ]
      );
    }

    let signalStrengthHistory = [];

    if (Array.isArray(signalStrengthHistoryData)) {
      signalStrengthHistoryData.sort((a, b) => new Date(a[0]) - new Date(b[0]));
      signalStrengthHistoryData.forEach((signalStrength) => {
        signalStrengthHistory = [
          ...signalStrengthHistory,
          [signalStrength[0], signalStrength[1].value],
        ];
      });
    }

    yield put(fetchSignalHistorySuccess(signalStrengthHistory));
  } catch (error) {
    yield put(fetchSignalHistoryFailure(error.message));
  }
}

async function fetchSignalHistoryAPI(deviceId, startDateTime, endDateTime) {
  const response = await fetch(fetchassetmapEndPoint(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      $filter: `(deviceid eq '${deviceId}' AND $/fields containskey 'signalStrength' AND createdon between('${startDateTime}','${endDateTime}'))`,
      $sort: [{ field: "createdon", order: "asc" }],
    }),
  });

  if (!response.ok) return [];

  return response.json();
}

export function* DeviceShipmentRSSIHistorySaga() {
  yield takeLatest(
    deviceShipmentsDashboardTypes.FETCH_RSSI_HISTORY_REQUEST,
    fetchRSSIHistorySaga
  );
}

export function* DeviceShipmentHumiditySaga() {
  yield takeLatest(
    deviceShipmentsDashboardTypes.FETCH_HUMIDITY_REQUEST,
    fetchHumiditySaga
  );
}

export function* DeviceShipmentLightSaga() {
  yield takeLatest(
    deviceShipmentsDashboardTypes.FETCH_LIGHT_REQUEST,
    fetchLightSaga
  );
}

export function* DeviceShipmentTiltSaga() {
  yield takeLatest(
    deviceShipmentsDashboardTypes.FETCH_TILT_REQUEST,
    fetchTiltSaga
  );
}

export function* DeviceShipmentBatteryHistorySaga() {
  yield takeLatest(
    deviceShipmentsDashboardTypes.FETCH_BATTERY_HISTORY_REQUEST,
    fetchBatteryHistorySaga
  );
}
export function* DeviceShipmentTemperatureSaga() {
  yield takeLatest(
    deviceShipmentsDashboardTypes.FETCH_TEMPERATURE_REQUEST,
    fetchTemperatureSaga
  );
}

export function* DeviceShipmentPressureSaga() {
  yield takeLatest(
    deviceShipmentsDashboardTypes.FETCH_PRESSURE_REQUEST,
    fetchPressureSaga
  );
}

export function* DeviceShipmentSignalHistorySaga() {
  yield takeLatest(
    deviceShipmentsDashboardTypes.FETCH_SIGNAL_HISTORY_REQUEST,
    fetchSignalHistorySaga
  );
}

function* fetchShockAlarmHistorySaga() {
  try {
    const options = yield select((state) => {
      return {
        currentId: state.shipmentDashboard.currentId,
        startDateTime: state.shipmentDashboard.startDateTime,
        endDateTime: state.shipmentDashboard.endDateTime,
      };
    });

    const shockHistoryResponse = yield call(
      fetchShockAlarmAPI,
      options.currentId,
      options.startDateTime,
      options.endDateTime
    );

    let shockHistory = {
      timeAgo: "",
      shock: [],
    };

    if (shockHistoryResponse && shockHistoryResponse.data) {
      shockHistory = shockHistoryResponse.data.reduce(
        (acc, shockData) => {
          // Extract magnitude from deviceAlarm.shock structure
          let magnitude = shockData.fields?.deviceAlarm?.shock?.magnitude;

          if (magnitude === undefined || magnitude === null) {
            const shockField = shockData.fields?.shock;
            magnitude = typeof shockField === 'number' ? shockField : undefined;
          }

          if (magnitude === undefined || magnitude === null) {
            const magField = shockData.fields?.magnitude;
            magnitude = typeof magField === 'number' ? magField : 0;
          }

          // Build event payload for tooltip/details
          const eventPayload = shockData.fields?.deviceAlarm ? {
            kind: 'shock',
            deviceAlarm: shockData.fields.deviceAlarm
          } : {
            // Fallback for old format
            axis: shockData.fields.axis || {},
            location: shockData.fields.location || {},
          };

          // Only add data points with valid magnitude values
          if (typeof magnitude === 'number') {
            acc.shock = [
              ...acc.shock,
              [
                shockData.createdon,
                magnitude,
                eventPayload
              ],
            ];
          }

          return acc;
        },
        {
          timeAgo: "",
          shock: [],
        }
      );
    }

    const lastShockEntry = shockHistory?.shock?.[shockHistory.shock.length - 1];
    shockHistory = {
      ...shockHistory,
      timeAgo: lastShockEntry ? timeAgoCalculator(lastShockEntry[0]) : "",
    };

    yield put(fetchShockAlarmHistorySuccess(shockHistory));
  } catch (error) {
    yield put(fetchShockAlarmHistoryFailure(error.message));
  }
}

async function fetchShockAlarmAPI(deviceId, startDateTime, endDateTime) {
  const response = await fetch(fetchassetmapEndPoint(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
      "X-Transaction-Id": uuidv4(),
    },
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      $filter: `(deviceid eq '${deviceId}' AND $/fields containskey 'deviceAlarm' AND createdon between('${startDateTime}','${endDateTime}'))`,
      $sort: [{ field: "createdon", order: "asc" }],
    }),
  });

  if (!response.ok) return { data: [] };

  return response.json();
}

export function* DeviceShipmentShockAlarmHistorySaga() {
  yield takeLatest(
    deviceShipmentsDashboardTypes.FETCH_SHOCK_ALARM_HISTORY_REQUEST,
    fetchShockAlarmHistorySaga
  );
}
